import React, { useState, useMemo } from 'react';
import PageShell from '../components/PageShell';
import ViewSwitch from '../components/ViewSwitch';
import { useHubExcelExport } from '../components/ExcelExportButton';
import { useRegisterPageExports } from '../exports/pageExports';
import PrintReportDocument from './PrintReportDocument';
import { usePersistentValue } from '../hooks/usePersistentState';
import { useP } from '../i18n/useP';
import FinancialsWorkingCapitalTab from './FinancialsWorkingCapitalTab';

/* BFRE — section seule du groupe Rapports (sortie du hub Rapports le
   2026-08-12) : composantes du besoin en fonds de roulement d'exploitation
   en 12 mois glissants, puis délais de rotation (DSO/DIO/DPO). La VUE
   (Réel | Prévisionnel) sur le filet, l'unité à droite ; PDF et Excel sont
   déclarés au registre et sortent par l'icône télécharger de la barre
   supérieure — même grammaire que les autres sections. */
export default function BfreCommandPage({ activeTenant, addToast, year }) {
  const p = useP();
  const tid = activeTenant?.id;
  const [vue, setVue] = usePersistentValue(`bfre_vue_${tid}`, 'reel');
  const [unit, setUnit] = usePersistentValue(`bfre_unit_${tid}`, 'kchf');
  /* L'unité monte à la BANDE DE CONTEXTE, comme partout ailleurs (2026-09-18) :
     elle tenait la droite de la ligne des modes, où elle changeait de place
     d'un écran à l'autre. Le gabarit la place, la page la déclare. */
  const pageUnit = useMemo(() => ({ value: unit, onChange: setUnit }), [unit, setUnit]);
  const [showPrint, setShowPrint] = useState(false);

  const renderBody = (u, forecastView) => (
    <FinancialsWorkingCapitalTab section="treasury" forecastView={forecastView}
      activeTenant={activeTenant} year={year} unit={u} />
  );

  const excel = useHubExcelExport({
    tabs: [{ label: 'BFRE', render: () => renderBody('chf', vue === 'prev') }],
    fileBase: 'BFRE',
    tenantName: activeTenant?.name,
    year,
    addToast,
  });
  useRegisterPageExports(useMemo(() => ([
    { id: 'pdf', label: 'PDF', run: () => setShowPrint(true) },
    { id: 'excel', label: 'Excel', run: excel.run },
  ]), [excel.run]));

  return (
    <PageShell framed kind="report" unit={pageUnit} title={p('BFRE')}>
      <nav className="tabs">
        <div className="tabs__list">
          <ViewSwitch
            ariaLabel={p('Vue')}
            value={vue}
            onChange={setVue}
            options={[{ id: 'reel', label: p('Réel') }, { id: 'prev', label: p('Prévisionnel') }]}
          />
        </div>
      </nav>
      <div className="page-shell__panel">
        {renderBody(unit, vue === 'prev')}
      </div>
      {excel.stage}

      {showPrint && (
        <PrintReportDocument
          activeTenant={activeTenant}
          year={year}
          reports={['liquidity-bfre']}
          mode="pdf"
          onClose={() => setShowPrint(false)}
        />
      )}
    </PageShell>
  );
}

